import React from 'react'
import { TextField } from '@material-ui/core'
import { useCadastro, useGlobalRefresh } from '../context/AppContext'
import InputMask from 'react-input-mask'
import { onlyNumbers } from '../functions/helpers'

export default function TxtRg(props) {
    const [update, setUpdate] = React.useState(0)
    const { cadastro } = useCadastro()
    const { globalRefresh } = useGlobalRefresh()
    
    const handleChange = (e) => {
        const { value } = e.target
        cadastro.rg = value
        setUpdate(u => u + 1)
    }

    React.useEffect(() => { }, [update, globalRefresh])

    return (
        <React.Fragment>
            <InputMask
                mask="99.999.999-9"
                value={cadastro.rg}
                onChange={handleChange}
            >
            {    
                () => <TextField required style={{width: props.w, marginLeft: props.ml}} label="RG"
                error={onlyNumbers(cadastro.rg).length < 9 && props.saved !== 0} inputProps={{ inputMode: 'numeric' }} />
            }
            </InputMask>

        </React.Fragment>
    );
}